import { useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

export function useChatDepartments(storeId: string | undefined) {
  return useQuery({
    queryKey: conversationKeys.departments(storeId ?? ''),
    queryFn: () => conversationsApi.departments(storeId ?? ''),
    staleTime: 5 * 60_000,
    enabled: Boolean(storeId),
  });
}
